module.exports = __webpack_public_path__ + "static/WEDDING E&M-98-45c7a8c3000a2e8b5cac095ea000587a.jpg";